"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _omit = _interopRequireDefault(require("transmute/omit"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _reactDom = require("react-dom");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _PropertyValidations = require("customer-data-properties/validation/PropertyValidations");

var propTypes = (0, _extends2.default)({
  autoFocus: _react.PropTypes.bool,
  showError: _react.PropTypes.bool,
  value: _react.PropTypes.string
}, _UITextInput.default.propTypes);
var defaultProps = _UITextInput.default.defaultProps;
var omitProps = (0, _omit.default)(['actions', 'baseUrl', 'caretRenderer', 'isInline', 'isExpandableTextInputEnabled', 'getProperty', 'multiCurrencyCurrencyCode', 'objectType', 'onCancel', 'onInvalidProperty', 'propertyIndex', 'readOnlySourceData', 'resolver', 'showError', 'subject', 'subjectId', 'secondaryChanges', 'showPlaceholder', 'onSecondaryChange', 'onTracking', 'isRequired']);

var PropertyInputDomain =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputDomain, _React$Component);

  function PropertyInputDomain() {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyInputDomain);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputDomain).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      hasBlurred: false
    };
    return _this;
  }

  (0, _createClass2.default)(PropertyInputDomain, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        this.focus();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      // eslint-disable-next-line react/no-find-dom-node
      var node = (0, _reactDom.findDOMNode)(this.refs.input);
      node.focus();
      return node.select();
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var value = this.props.value;

      if (value == null) {
        return value;
      }

      return "" + value;
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      return this.setState({
        hasBlurred: true
      });
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      return this.setState({
        hasBlurred: false
      });
    }
  }, {
    key: "shouldShowError",
    value: function shouldShowError() {
      var hasBlurred = this.state.hasBlurred;
      var showError = this.props.showError;
      var propertyValue = this.getValue();
      return showError && hasBlurred && propertyValue && propertyValue.length && !(0, _PropertyValidations.isValidDomain)(propertyValue);
    }
  }, {
    key: "renderValidationError",
    value: function renderValidationError() {
      var propertyValue = this.getValue();

      if (!this.shouldShowError()) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "is--text--error"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "customerDataProperties.PropertyDomain.error.invalidDomain",
        options: {
          domain: propertyValue
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var transferableProps = omitProps(this.props);
      return _react.default.createElement(_UIGridItem.default, {
        size: {
          xs: 12
        },
        className: "p-x-0"
      }, _react.default.createElement(_UITextInput.default, (0, _extends2.default)({}, transferableProps, {
        "data-modalfocus": this.props.autoFocus,
        value: this.getValue(),
        ref: "input",
        onBlur: this.handleBlur,
        onFocus: this.handleFocus
      })), this.renderValidationError());
    }
  }]);
  return PropertyInputDomain;
}(_react.default.Component);

PropertyInputDomain.propTypes = propTypes;
PropertyInputDomain.defaultProps = defaultProps;
var _default = PropertyInputDomain;
exports.default = _default;
module.exports = exports.default;